module.exports = __webpack_public_path__ + "img/i01.628a2cd4.svg";